import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import Link from '@/_application/core/components/ui/link';
import {SwiperSlide} from 'swiper/react';
import {Image} from '@/_application/core/components/ui/image';
import {Banner} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

interface BannerCollectionProps {
    categoryBanners: Banner[];
}

const breakpoints = {
    768: {
        slidesPerView: 2,
        spaceBetween: 16,
    },
    1280: {
        slidesPerView: 3,
        spaceBetween: 20,
    },
};

function CategoryBannerCollection({categoryBanners}: Readonly<BannerCollectionProps>) {
    if (!categoryBanners?.length) {
        return <></>;
    }

    return (
        <div className="mt-5 rounded-[20px] bg-[#FFCC3233] px-[22px] py-5">
            <h3 className="text-[22px] font-extrabold leading-[25px] text-primary">Bộ sưu tập</h3>

            <CustomSwiper
                className="mt-5 rounded-2xl "
                slidesPerView={3}
                spaceBetween={21}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                hasNavigation
                buttonPrevClassName="-left-10 top-[calc(50%-1.5rem)]"
                buttonNextClassName="-right-10 top-[calc(50%-1.5rem)]"
                loop={true}
                breakpoints={breakpoints}>
                {categoryBanners?.map(item => {
                    if (!item?.image) return <></>;

                    const imageUrl = getBannerUrlByPath(item.image);

                    return (
                        <SwiperSlide key={item?.banner_id}>
                            <Link href={`${item?.url_banner}`}>
                                <div className="relative h-full">
                                    <Image
                                        width={372}
                                        height={180}
                                        src={imageUrl}
                                        alt="Banner"
                                        className="h-full w-full rounded-[1.25rem] object-cover"
                                    />
                                </div>
                            </Link>
                        </SwiperSlide>
                    );
                })}
            </CustomSwiper>
        </div>
    );
}

export default CategoryBannerCollection;
